const state = {
  editedFields: [],
};

export default state;
